import { useQuery } from '@tanstack/react-query';
import { get_automation_version_url } from '@/utils/urls';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { AUTOMATION_VERSION_KEY } from '@/utils/queryKeys.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationVersion } from '@/types/automations.ts';

const useRetrieveAutomationVersion = (versionId?: string) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery<AutomationVersion, Error>({
    queryKey: AUTOMATION_VERSION_KEY(automationId, versionId || ''),
    queryFn: async () => {
      const response = await apiClient.get(get_automation_version_url(versionId));
      return response.data;
    },
    enabled: !!versionId,
  });
};

export default useRetrieveAutomationVersion;
